import React from "react";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Alert,
    Stack,
    CircularProgress
} from "@mui/material";
import { api, baseURL } from "../../services/api";
import { maskCPF2 } from "../../utils/mask";
import { validateBr } from 'js-brasil';

export default function Certificates() {
    const [cpf, setCpf] = React.useState("");
    const [certificates, setCertificates] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [generateCertificate, setGenerateCertificate] = React.useState(false);
    const normalizedPassport = cpf.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
    const isValidCpf = validateBr.cpf(cpf);
    const isValidPassport = /^[A-Z0-9]{6,20}$/.test(normalizedPassport);
    const canSearch = isValidCpf || isValidPassport;

    const handleSearchCertificates = async () => {
        setError("");
        setCertificates([]);
        if (!canSearch) {
            setError("Digite um CPF válido ou um passaporte com 6 a 20 caracteres.");
            return;
        }
        const document = isValidCpf ? cpf : normalizedPassport;
        setCpf(document);
        setLoading(true);
        try {
            const { data } = await api.post(`/certificates`, { data: { document } });
            if (!data || data.length === 0) {
                setError("Nenhum certificado encontrado para este documento.");
                setLoading(false);
                return;
            }
            setCertificates(data);
        } catch (err) {
            setError("Erro ao buscar certificados. Tente novamente.");
        }
        setLoading(false);
    };
    async function handleCertificate({ event }) {
        setGenerateCertificate(true)
        try {
            const certificate = await api.post('/certificates', { data: { document: cpf, event } })
            if (certificate.status === 200) {
                window.open(`${baseURL + certificate.data[0].url}`, '_blank');
            }
            setGenerateCertificate(false)
        } catch (error) {
            console.log(error)
            setGenerateCertificate(false)
            alert(error.response.data.error.message)
        }
    }

    return (
        <React.Fragment>
            <Box sx={{ maxWidth: 900, margin: "auto", padding: 4 }}>
                <Typography variant="h4" align="center" gutterBottom fontWeight={700} color="#004D91">
                    Consulta de Certificados
                </Typography>
                <Paper elevation={3} sx={{ padding: 4, mb: 4 }}>
                    <Stack spacing={3}>
                        <TextField
                            label="CPF ou passaporte"
                            value={cpf}
                            onChange={e => {
                                const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                setCpf(/^\d{11}$/.test(value) && validateBr.cpf(value) ? maskCPF2(value) : value);
                            }}
                            inputProps={{ maxLength: 20 }}
                            fullWidth
                            error={!!error}
                            helperText="Informe um CPF válido ou um passaporte com 6 a 20 caracteres"
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSearchCertificates}
                            disabled={loading || !canSearch}
                        >
                            {loading ? <CircularProgress size={24} /> : "Buscar Certificados"}
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                    </Stack>
                </Paper>

                {certificates.length > 0 && (
                    <Paper elevation={2} sx={{ padding: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Certificados encontrados
                        </Typography>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Evento</b></TableCell>
                                        <TableCell><b>Categoria</b></TableCell>
                                        <TableCell><b>Certificado</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {certificates.map((cert, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell>{cert.name}</TableCell>
                                            <TableCell>{cert.certificateType === 'speaker' ? 'Palestrante' : 'Participante'}</TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    component="a"
                                                    onClick={() => handleCertificate({ event: cert.name })}
                                                    target="_blank"
                                                    disabled={generateCertificate}
                                                    rel="noopener noreferrer"
                                                >
                                                    <Typography variant='text'>{generateCertificate ? 'gerando certificado' : 'buscar certificado'}</Typography>
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                )}
            </Box>
        </React.Fragment>
    );
}